import type { CSSProperties, ReactNode } from "react";
import { useEmbedTokens } from "../theme";

interface Props {
  level: 1 | 2 | 3;
  subtitle?: string;
  children: ReactNode;
}

// A heading with an optional secondary subtitle line beneath it.
export function EmbedHeading({ level, subtitle, children }: Props) {
  const t = useEmbedTokens();
  const byLevel: Record<1 | 2 | 3, { fontSize: number; fontWeight: number }> = {
    1: { fontSize: t.fontSize.xl, fontWeight: 700 },
    2: { fontSize: t.fontSize.lg, fontWeight: 600 },
    3: { fontSize: t.fontSize.md, fontWeight: 600 },
  };
  const headingStyle: CSSProperties = {
    margin: 0, color: t.colors.text, lineHeight: t.lineHeight.tight,
    fontSize: byLevel[level].fontSize, fontWeight: byLevel[level].fontWeight,
  };
  const subtitleStyle: CSSProperties = {
    margin: `${t.spacing.xs}px 0 0`, color: t.colors.textSecondary,
    fontSize: t.fontSize.sm, lineHeight: t.lineHeight.normal,
  };
  const Tag = `h${level}` as "h1" | "h2" | "h3";
  return (
    <div>
      <Tag style={headingStyle}>{children}</Tag>
      {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
    </div>
  );
}
